export const DeliveryProviderMerchantConfigurationTypes = {
  Enabled: 'Delivery Provider Enable',
  DeliveryProvider: 'Delivery Provider',
  ApplicationSource: 'Delivery Provider Application Source'
} as const;
